document.addEventListener('DOMContentLoaded', function () {
	coopDragNDrop()
	showMore.call(document.querySelector('.works-designers__btn > button'))
})
